import {createReducer} from '@reduxjs/toolkit';
import {selectMosaic, setMosaicsMode} from '@src/actions/mosaics';
import {MODES} from '@src/constants/mosaics';

export const initialState = {
  selected: null, // definition of the selected mosaic.
  mode: MODES.MOSAICS,
};

const mosaics = createReducer(initialState, builder => {
  builder.addCase(selectMosaic, (state, {payload: mosaic}) => {
    state.selected = mosaic;
  });

  builder.addCase(setMosaicsMode, (state, {payload: mode}) => {
    state.mode = mode;
  });
});

export default mosaics;
